// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__14Rwc","signatureButtonsRight":"ModalSign_signatureButtonsRight__1Vmof"};